import { vuexLogistic } from '@/store/composition/module/logistic'
import { LOGISTIC_TRANSPORT_URL } from '@/api/Logistic'

const state = () => ({
  ...vuexLogistic.createState(),
  urlApi: LOGISTIC_TRANSPORT_URL,
  expand: 'fuel,waybills',
  deleteResponseKey: 'name',

  tableHeaders: [
    {
      title: 'Наименование',
      isSortable: false
    },
    {
      title: 'Номер',
      isSortable: false
    },
    {
      title: 'Не рабочий одометр',
      isSortable: false
    },
    {
      title: 'Комментарий',
      isSortable: false
    },
    {
      title: 'Сортировка',
      isSortable: false
    }
  ]
})

const getters = {
  ...vuexLogistic.createGetters(),

  getList: state => {
    return state.list.map(item => {
      return {
        id: item.id,
        isActive: item.isActive,
        values: [
          item.name,
          item.number,
          item.is_not_odometer ? 'Да' : 'Нет',
          item.comment || '-',
          item.sort_order
        ]
      }
    })
  },

  getSelectList: state => {
    return state.list.map(item => {
      return {
        id: item.id,
        name: `${item.name} ${item.number}`
      }
    })
  },

  itemIsUsed: state => {
    return state.checkedDeleteItem?.waybills?.length
  }
}

const mutations = {
  ...vuexLogistic.createMutations()
}

const actions = {
  ...vuexLogistic.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
